import { IconButton } from '@fluentui/react';
import { HighContrastSelector } from '@fluentui/react';
import React from 'react';

const ArcSplitButton = (props) => {

    const icon = { iconName: props.icon };

    const customSplitButtonStyles = {
        splitButtonMenuButton: { backgroundColor: 'white', width: 28, border: 'none' },
        splitButtonMenuIcon: { fontSize: '7px' },
        splitButtonDivider: { backgroundColor: '#c8c8c8', width: 1, right: 26, position: 'absolute', top: 4, bottom: 4 },
        splitButtonContainer: {
          selectors: {
            [HighContrastSelector]: { border: 'none' },
          },
        },
      };

    return (
        <React.Fragment>
            <IconButton
                split
                iconProps={icon}
                aria-roledescription="split button"
                styles={customSplitButtonStyles}
                menuProps={props.options}
                ariaLabel="New item"
                onClick={props.onClick}
            />
        </React.Fragment>
    )
}

export default ArcSplitButton;